import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../contexts/AuthContext";
import { ApiError, api } from "../services/api";

type LoginResponse = { access_token: string; token_type: string; expires_in: number };

export default function LoginPage() {
  const { t } = useTranslation();
  const { setToken, deviceId } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = await api.post<LoginResponse>("/api/auth/login", {
        email,
        password,
        device_id: deviceId,
      });
      setToken(res.access_token);
      navigate("/dashboard");
    } catch (err) {
      if (err instanceof ApiError && err.status === 403) {
        setError(t("auth.errorLicense"));
      } else {
        setError(t("auth.errorInvalid"));
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="placeholder">
      <h1>{t("auth.loginTitle")}</h1>
      <form onSubmit={onSubmit}>
        <label>
          {t("auth.email")}
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
        </label>
        <label>
          {t("auth.password")}
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </label>
        <button type="submit" disabled={busy}>
          {t("auth.submit")}
        </button>
        {error && <p style={{ color: "var(--color-danger)" }}>{error}</p>}
      </form>
    </div>
  );
}
